import React from 'react';
import SDL from '../../Assets/images/spenser-leighton-vhs.svg';
import './styles.scss';

export const Footer = () => (
    <footer>
        <p className="copy">© 2022 Jeremy Charles Burns. All rights reserved.</p>
        <a class="sdl" target="_blank" href="https://spenserleighton.com/">
            <img src={ SDL } alt="Spenser Leighton Design/Build" />
        </a>
    </footer>
)